import classNames from 'classnames';
import Dropdown from 'react-bootstrap/Dropdown';
import styles from './ProductSortSelection.module.scss';

export default function DropdownOptions({
  selectedSort,
  sortOptions,
  onSelection,
}) {
  return sortOptions.map((current, index) => {
    const key = current.value;
    const isLastChild = sortOptions.length === index + 1;
    const spacer = isLastChild ? 'mb-0' : 'mb-3';
    return (
      <Dropdown.Item
        key={key}
        aria-label={`Select ${current?.label} sort option`}
        active={key === selectedSort.value}
        className={classNames(
          'p-6 font-roboto fs-8 text-primary',
          styles.dropDownItem,
          spacer
        )}
        eventKey={key}
        onClick={() => onSelection(current)}
      >
        {current.label}
      </Dropdown.Item>
    );
  });
}
